import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";
const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = checking

  useEffect(() => {
    axios.get(`${API}/auth/me`, { withCredentials: true })
      .then(r => setUser(r.data))
      .catch(() => setUser(null));
  }, []);

  const login = async (email, password, opts = {}) => {
    const body = { email, password };
    if (opts.totp_code) body.totp_code = opts.totp_code;
    if (opts.tenant_id) body.tenant_id = opts.tenant_id;
    const r = await axios.post(`${API}/auth/login`, body, { withCredentials: true });
    if (r.data?.require_2fa) return { require_2fa: true, email: r.data.email, tenant_id: r.data.tenant_id };
    if (r.data?.select_tenant) return { select_tenant: true, tenants: r.data.tenants };
    setUser(r.data);
    // Cache workspace slug for next login to auto-show branding
    if (r.data?.tenant_slug) {
      axios.get(`${API}/tenants/branding/public`, { params: { slug: r.data.tenant_slug } })
        .then(res => localStorage.setItem("daton_public_branding", JSON.stringify(res.data)))
        .catch(() => {});
    }
    return r.data;
  };

  const signup = async (data) => {
    const r = await axios.post(`${API}/tenants/signup`, data, { withCredentials: true });
    setUser(r.data);
    return r.data;
  };

  const logout = async () => {
    try { await axios.post(`${API}/auth/logout`, {}, { withCredentials: true }); } catch {}
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, signup }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

export function formatApiError(detail) {
  if (!detail) return "Ein Fehler ist aufgetreten.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map(e => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}
